import { render, staticRenderFns } from "./PartsGroups.vue?vue&type=template&id=c5e21a68&"
import script from "./PartsGroups.vue?vue&type=script&lang=ts&"
export * from "./PartsGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports